import { useOutletContext } from 'react-router'
import {
  EventDetail,
  EventSummary,
  BotInfo,
  ChannelSubscription
} from 'types/api'

export interface EventDetailContextValue {
  event: EventDetail
  bot: BotInfo | null
  subscriptions: ChannelSubscription[]
  allEvents: EventSummary[]
  setEvent: React.Dispatch<React.SetStateAction<EventDetail | null>>
  refetchEvent: () => Promise<void>
  refetchSubscriptions: () => Promise<void>
}

export const useEventDetail = (): EventDetailContextValue =>
  useOutletContext<EventDetailContextValue>()
